import { useEffect, useRef, useState } from 'react';

const InfoCards = () => {
  const [visibleCards, setVisibleCards] = useState<number[]>([]);
  const cardsRef = useRef<(HTMLDivElement | null)[]>([]);

  const cards = [
    {
      icon: 'ri-map-pin-line',
      title: 'Kongre Yeri',
      description: 'İstanbul Atlas Üniversitesi Kongre Merkezi, Kağıthane',
      color: 'from-teal-500 to-cyan-500',
      bgColor: 'bg-teal-50',
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Tarih',
      description: '02 – 03 Mayıs 2026.',
      color: 'from-orange-400 to-amber-500',
      bgColor: 'bg-orange-50',
    },
    {
      icon: 'ri-sun-line',
      title: 'İklim',
      description: 'Ortalama 18°C, açık ve güneşli hava.',
      color: 'from-yellow-400 to-orange-400',
      bgColor: 'bg-yellow-50',
    },
    {
      icon: 'ri-award-line',
      title: 'Katılım Sertifikası',
      description: 'Kongreye kayıt yaptıran ve katılan tüm katılımcılara sertifika verilecektir.',
      color: 'from-emerald-500 to-teal-500',
      bgColor: 'bg-emerald-50',
    },
    {
      icon: 'ri-mail-send-line',
      title: 'Davet Mektubu',
      description: 'Kayıt yaptırmış tüm katılımcılara talep hâlinde davet mektubu gönderilecektir.',
      color: 'from-sky-500 to-cyan-500',
      bgColor: 'bg-sky-50',
    },
    {
      icon: 'ri-store-2-line',
      title: 'Stand Alanı',
      description: 'Ürün sahibi firmalar, ürünlerini kongre merkezi fuayesinde sergileyebilecektir.',
      color: 'from-violet-500 to-indigo-500',
      bgColor: 'bg-violet-50',
    },
    {
      icon: 'ri-cup-line',
      title: 'Kahve Molası',
      description: 'Kongre süresince çay ve kahve ikramları fuaye ve stand alanlarından servis edilecektir.',
      color: 'from-amber-500 to-yellow-500',
      bgColor: 'bg-amber-50',
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Kongre Konsepti',
      description: 'Kongre boyunca öğle yemeği ve kahve molası servisi yapılacaktır.',
      color: 'from-rose-500 to-pink-500',
      bgColor: 'bg-rose-50',
    },
    {
      icon: 'ri-compass-3-line',
      title: 'Çevre Gezileri',
      description: 'Kongre öncesi ve sonrası çevre gezileri talep üzerine düzenlenebilir. Tur masası kongre kayıt alanında kurulacaktır.',
      color: 'from-green-500 to-emerald-500',
      bgColor: 'bg-green-50',
    },
  ];

  useEffect(() => {
    const observers = cardsRef.current.map((card, index) => {
      if (!card) return null;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              setVisibleCards((prev) => [...prev, index]);
            }, Math.floor(index / 3) * 100 + (index % 3) * 120);
          }
        },
        { threshold: 0.2 }
      );

      observer.observe(card);
      return observer;
    });

    return () => {
      observers.forEach((observer, index) => {
        if (observer && cardsRef.current[index]) {
          observer.unobserve(cardsRef.current[index]!);
        }
      });
    };
  }, []);

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-accent/10 rounded-full mb-4">
            <i className="ri-information-line text-accent"></i>
            <span className="text-accent font-semibold text-sm">Kongre Detayları</span>
          </div>
          <h2 className="font-display text-4xl font-bold text-primary">Bilmeniz Gerekenler</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {cards.map((card, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className={`${card.bgColor} rounded-2xl p-8 hover:shadow-2xl transition-all duration-700 hover:-translate-y-2 cursor-pointer group ${
                visibleCards.includes(index)
                  ? 'opacity-100 translate-y-0 scale-100'
                  : 'opacity-0 translate-y-8 scale-95'
              }`}
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${card.color} rounded-xl flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-500`}>
                <i className={`${card.icon} text-3xl text-white`}></i>
              </div>

              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {card.title}
              </h3>

              <p className="text-gray-700 leading-relaxed text-sm">
                {card.description}
              </p>

              <div className={`mt-6 h-1 w-12 bg-gradient-to-r ${card.color} rounded-full group-hover:w-full transition-all duration-500`}></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InfoCards;